import { SET_LOGIN_DATA, REMOVE_LOGIN_DATA, UPDATE_PROFILE } from '../constant';

export const updateAuthData = (payload) => ({ type: SET_LOGIN_DATA, payload });
export const removeAuthData = () => ({ type: REMOVE_LOGIN_DATA });
export const updateProfile = (payload) => ({ type: UPDATE_PROFILE, payload });
